import { Controller } from "stimulus"

export default class extends Controller {

  static targets = ["navbar", "statusUpdate", "statusUpdateActions"]

  static values = {
    page: String,
    uuid: String
  }

  connect() {
    let that = this;

    if(this.hasNavbarTarget) {
      const navLink = this.navbarTarget.querySelector(`a[data-page="${this.pageValue}"]`)

      if(navLink) {
        navLink.classList.add("text-white")
      }
    }
    $('.nav a').on('click', function(){
      if($(this).attr("id") != "btnmore" && $(this).attr("id") != "btnadd") {
        if($(".project-navigation .navbar-toggle").css('display') !='none'){
          $(".project-navigation .navbar-toggle").click();
        }
      }
    });

    $('.nav a').on('click', function(){
      if($(this).attr("id") != "btnmore" && $(this).attr("id") != "btnadd") {
        if($(".project-navigation .navbar-toggle").css('display') !='none'){
          $(".project-navigation .navbar-toggle").click();
        }
      }
    });

    if(this.hasStatusUpdateTarget) {
      this.statusUpdateTarget.addEventListener('focus', () => {
        that.statusUpdateActionsTarget.classList.add("d-flex");
        that.statusUpdateActionsTarget.classList.remove("d-none");
      })
      this.statusUpdateTarget.addEventListener('blur', () => {
        if(that.statusUpdateTarget.value.trim() == "") {
          that.statusUpdateActionsTarget.classList.add("d-none");
          that.statusUpdateActionsTarget.classList.remove("d-flex");
        }
      })
    }

    /*
    <% if(params[:task]) %>
    $.ajax({url: '<%= url_for controller: 'tasks', action: 'show', task: params[:task], locale: I18n.locale %>'});
    <% elsif(params[:file]) %>
    $.ajax({url: '<%= url_for controller: 'files', action: 'show', file: params[:file], locale: I18n.locale %>'});
    <% elsif(params[:event]) %>
    $.ajax({url: '<%= url_for controller: 'events', action: 'show', event: params[:event], locale: I18n.locale %>'});
    <% elsif(params[:note]) %>
    $.ajax({url: '<%= url_for controller: 'notes', action: 'show', note: params[:note], locale: I18n.locale %>'});
    <% elsif(params[:page]) %>
    $.ajax({url: '<%= url_for controller: 'pages', action: 'show', page: params[:page], locale: I18n.locale %>'});
    <% elsif(params[:activity]) %>
    $.ajax({url: '<%= url_for controller: 'activities', action: 'show', activity: params[:activity], locale: I18n.locale %>'});
    <% elsif(params[:blogpost]) %>
    $.ajax({url: '<%= url_for controller: 'blog', action: 'show', blogpost: params[:blogpost], locale: I18n.locale %>'});
    <% elsif(params[:bookmark]) %>
    $.ajax({url: '<%= url_for controller: 'bookmarks', action: 'show', bookmark: params[:bookmark], locale: I18n.locale %>'});
    <% end %>

    <% if(@events.size > 0) %>
    $("#events").show();
    $("#events").html("<%= escape_javascript(render @events)%>");
    <% else %>
    $("#events").hide();
    <% end %>

    <% if(@tasks.size > 0) %>
    $("#tasks").show();
    $("#tasks").html("<%= escape_javascript(render @tasks)%>");
    <% else %>
    $("#tasks").hide();
    <% end %>

    <% if(@events.size == 0 && @tasks.size == 0) %>
    $("#upcomings").hide();
    <% else %>
    $("#upcomings").show();
    <% end %>

    <% if(@pins.size > 0) %>
    $("#pins-container").show();
    $("#pins").html("<%= escape_javascript(render partial: 'projects/pin', collection: @pins)%>");
    <% else %>
    $("#pins-container").hide();
    <% end %>

    $("#btnUpdatePost").hide();
    $("#btnUpdateCancel").hide();

    $('[data-toggle="confirmation"]').confirmation({
      rootSelector: '[data-toggle=confirmation]',
      onConfirm: function(){
        Rails.ajax({
          url: `/<%= I18n.locale %>/projects/update/${$(this).data('message')}/remove`,
                   type: "delete",
                   data: "",
                   success: function(data) {},
                   error: function(data) {}
        });
      }
    });

    $("#status_comment").click(function() {
      $("#status_comment").css('height', '79px');
      $("#btnUpdatePost").fadeIn('fast');
      $("#btnUpdateCancel").fadeIn('fast');
    });

    $("#btnUpdateCancel").click(function() {
      $("#btnUpdatePost").fadeOut('fast');
      $("#btnUpdateCancel").fadeOut('fast');
      $("#status_comment").val('');
      $("#status_comment").css('height', '29px');
    });
*/

    cowork.loadingFadeOut()
  }

  navigationSetCalendar() {
    setTimeout(() => {
      if(this.hasNavbarTarget) {

        const navLink = this.navbarTarget.querySelector(`a[data-page="calendar"]`)
        navLink.classList.add("text-white")
      }
    }, 200);

    window.history.pushState({}, "", `/en/project/${this.uuidValue}`);
  }

  toggleFeature() {
    var feature = event.target.dataset.feature;
    var enabled = event.target.checked;

    event.target.dataset.enabled = enabled;
    Rails.ajax({
      url: `/${I18n.locale}/projects/${this.uuidValue}/feature/${feature}/${enabled}`,
      type: "post",
      success: function(data) {},
      error: function(data) {}
    });
  }

  restoreFile() {
    var fhash = event.target.dataset.fhash;
    var locale = event.target.dataset.locale;

    bootbox.dialog({
      message: event.target.dataset.confirmation,
      title: event.target.dataset.restore,
      onEscape: true,
      buttons: {
        cancel: {
          label: event.target.dataset.btn_cancel,
          className: "btn-outline-secondary",
        },
        create: {
          label: event.target.dataset.btn_restore,
          className: "btn-success",
          callback: function() {
            $.ajax(`/${locale}/files/${fhash}/restore`)
            .done(function() {
              $(`#deleted_file${fhash}`).fadeOut('100');
            })
            .always(function() {
              bootbox.hideAll();
            });
          }
        }
      }
    });
  }

  purgeFile() {
    var fhash = event.target.dataset.fhash;
    var locale = event.target.dataset.locale;

    bootbox.dialog({
      message: event.target.dataset.confirmation,
      title: event.target.dataset.purge,
      onEscape: true,
      buttons: {
        cancel: {
          label: event.target.dataset.btn_cancel,
          className: "btn-outline-secondary",
        },
        create: {
          label: event.target.dataset.btn_purge,
          className: "btn-danger",
          callback: function() {
            $.ajax(`/${locale}/files/${fhash}/purge`)
            .done(function() {
              $(`#deleted_file${fhash}`).fadeOut('100');
            })
            .always(function() {
              bootbox.hideAll();
            });
          }
        }
      }
    });
  }
}
